module.exports = function() {
  return new Worker(__webpack_public_path__ + "5af032bc6bf5fe5827b0.worker.js");
};